"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _classnames = _interopRequireDefault(require("classnames"));

require("./_replies.scss");

function getReplyString(_ref) {
  var numberReplies = _ref.numberReplies;
  return 1 < numberReplies ? "".concat(numberReplies, " replies") : "".concat(numberReplies, " reply");
}

function Replies(_ref2) {
  var numberReplies = _ref2.numberReplies,
      _ref2$assetIds = _ref2.assetIds,
      assetIds = void 0 === _ref2$assetIds ? [] : _ref2$assetIds,
      bothVisible = numberReplies && assetIds.length;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("comment-replies", {
      "comment-replies--both-visible": bothVisible
    })
  }, numberReplies ? _react["default"].createElement("span", null, getReplyString({
    numberReplies: numberReplies
  })) : null, assetIds.length ? _react["default"].createElement(_uiKit.Icon, {
    name: "link",
    size: 15,
    color: "monkey"
  }) : null);
}

var _default = (0, _react.memo)(Replies);

exports["default"] = _default;